<app-metadata-add [tipoPratica]="tipoPratica"></app-metadata-add>
